import React from 'react';
import PropTypes from 'prop-types';

export const HeaderText = ({ text }) => (
    <span className='odf-h6 odf-text-mono-color-09 odf-text-center'>{text}</span>
);

HeaderText.propTypes = {
    text: PropTypes.string.isRequired,
};
